<template>
    <router-view />
</template>

<style lang="scss" src="@/assets/scss/app.scss" />
